
import React, { useContext, useEffect, useState } from 'react'
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Card from '../../../Base/Components/Card/Card';
import Loader from '../../../Base/Components/Loader/Loader';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { formatNumber } from '../../../Base/Services/TemplatesServices';

import { getProduccionFechaMesTintoreria } from '../../../API/Produccion/KPIs/KPIs';
import { colorCotton, colorProyeccion, colorSintetico, datalabelsLineCat, datalabelsLineGerencia, getTitle } from '../../../utils/KPIs/productionUtils';
import './MetasDialog.scss'
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
import plugin from 'chartjs-plugin-datalabels';
import { baseLang } from '../../../Base/Lang/BaseLang';
import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { borderColorCotton, borderColorSintetico } from '../../../Styles/Colors';
import DiarioMetasDiarias from './DiarioMetasDiarias';

const MetasSemanalesPorCategoria = ({ date, kpiGerencia, getDatos, altura, visible = true }) => {
    const { userAuth } = useContext(AuthContext);
    const [tempoCotton1, setTempoCotton1] = useState(false);
    const { config } = useContext(ConfigContext);

    const [loading, setLoading] = useState(false);
    const [chartCotton, setChartCotton] = useState({ data: {}, options: {} });
    const [semana, setSemana] = useState([]);
    const [showDialogDiario, setShowDialogDiario] = useState(false);
    const [IdCategoria, setIdCategoria] = useState(null)
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const colorTitle = getTitle(config);


    const [chartPoly, setChartPoly] = useState({
        data: {},
        options: {}
    });



    const getInfo = async () => {
        setChartCotton({
            data: {},
            options: {}
        });
        setChartPoly({
            data: {},
            options: {}
        });

        setLoading(true);


        const tempoCotton = await getProduccionFechaMesTintoreria({ month: date?.getMonth() + 1, year: date?.getFullYear() });
        setTempoCotton1(tempoCotton)
        let valuesCotton = [];
        let valuesSynthetic = [];
        let proyeccionCotton = [];
        let proyeccionSynthetic = [];

        tempoCotton?.forEach(element => {
            valuesCotton.push(element.KgsTiC);
            valuesSynthetic.push(element.KgsTiS);
            proyeccionCotton.push(element.KgsProyeccionAlgodon);
            proyeccionSynthetic.push(element.KgsProyeccionSintetico);
        });

        const data = [...tempoCotton]
        const semanaCorta = data?.map(item => item.Semana);



        const semanas = data?.map(item => config.language === 'en' ? `Week ${item.Semana}` : `Semana ${item.Semana}`);

        const config2 = {
            type: 'bar',
            datalabels: datalabelsLineCat,
            barPercentage: 0.4,
            barThickness: 80,
        }


        const optionsChart = {
            interaction: {
            },
            responsive: true,
            maintainAspectRatio: false,

            plugins: {
                title: {
                    display: true,
                },
                datalabels: {
                    align: 'start',
                    anchor: 'start',
                    offset: 5,
                    color: colorTitle,

                },
                legend: {
                    position: 'bottom',
                    labels: {
                        color: colorTitle,
                        font: {
                            size: 11,
                        },
                    },
                },
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: colorTitle,
                        minRotation: 0,
                        maxRotation: 0,
                        font: {
                            size: 11
                        }
                    },
                    barThickness: 100, // Ajusta el grosor de las barras
                    // maxBarThickness: 60, // Valor máximo de grosor
                },
                y: {
                    ticks: {
                        color: colorTitle,
                        callback: (val, index) => {
                            return (val > 0 ? formatNumber(val).replace('.00', '') + ' Kg' : '')
                        }
                    }
                }
            },
        }

        setChartCotton({
            data: {
                labels: semanas,
                datasets: [
                    {
                        datalabels: datalabelsLineCat,
                        type: "line",
                        label: "Target",
                        backgroundColor: borderColorCotton,
                        borderColor: borderColorCotton,
                        data: proyeccionCotton,
                        borderDash: [5, 5],
                    },
                    {
                        ...config2,
                        label: 'Real Cotton',
                        backgroundColor: colorCotton,
                        borderColor: colorCotton,
                        data: valuesCotton,
                    },
                ],
            },
            options: {
                ...optionsChart,
                onClick: (event, elements) => {
                    if (elements.length > 0) {
                        setIdCategoria(1)
                        const index = elements[0].index;
                        const semanaCorta = data?.map(item => item.Semana);
                        const clickedWeek = semanaCorta[index];
                        setShowDialogDiario(true)
                        setSemana(clickedWeek)
                    }
                },

            }
        })

        setChartPoly({
            data: {
                labels: semanas,
                datasets: [
                    {
                        datalabels: datalabelsLineCat,
                        type: "line",
                        label: "Target",
                        backgroundColor: borderColorSintetico,
                        borderColor: borderColorSintetico,
                        data: proyeccionSynthetic,
                        borderDash: [5, 5],
                    },
                    {
                        ...config2,
                        label: 'Real Synthetic',
                        backgroundColor: colorSintetico,
                        borderColor: colorSintetico,
                        data: valuesSynthetic,
                    },
                ],
            },
            options: {
                ...optionsChart,
                onClick: (event, elements) => {
                    if (elements.length > 0) {
                        setIdCategoria(2)
                        const index = elements[0].index;
                        const semanaCorta = data?.map(item => item.Semana);
                        const clickedWeek = semanaCorta[index];
                        setShowDialogDiario(true)
                        setSemana(clickedWeek)
                    }
                },

            }
        })

        setLoading(false);
    }

    const columns = [
        {
            // Customer
            field: 'Semana',
            header: 'Semana',
            headerEn: 'Week',
            className: 'small',
            Sumary: 'count',
            frozen: 'frozen',
            alignFrozen: 'left',
        },
        {
            // Rollos
            field: 'DateInicioSemana',
            header: 'Fecha Inicio',
            headerEn: 'Initial Date',
            className: 'large',
            Format: 'DateTime'
        },
        {
            // Rollos
            field: 'DateFinSemana',
            header: 'Fecha Fin',
            header: 'Final Date',
            className: 'large',
            Format: 'DateTime'
        },

        //REPROCESOS----------------------------------------------------------
        {
            headerName: 'Reprocesos',
            headerNameEn: 'Reprocess',
            children: [
                {
                    // Rollos
                    field: 'KgsTiRC',
                    header: 'Algodón',
                    headerEn: 'Cotton',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    // Rollos
                    field: 'KgsTiRS',
                    header: 'Sintético',
                    headerEn: 'Synthetic',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    // Rollos
                    field: 'KgsTir',
                    header: 'Total',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'RPercent',
                    header: 'Porcentaje',
                    headerEn: 'Porcentaje',
                    className: 'small',
                    Format: 'Porcentaje',
                },
            ]
        },


        //CAMBIO COLOR----------------------------------------------------------
        {
            headerName: 'Cambio Color',
            headerNameEn: 'Color Change',
            children: [
                {
                    field: 'KgsCCC',
                    header: 'Algodón',
                    headerEn: 'Cotton',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'KgsCCS',
                    header: 'Sintético',
                    headerEn: 'Synthetic',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'ColorC',
                    header: 'Total',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'CCPercent',
                    header: 'Porcentaje',
                    headerEn: 'Porcentage',
                    className: 'small',
                    Format: 'Porcentaje',
                    //    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Reproceso + CambioColor',
            headerNameEn: 'Reprocess + ChangeColor',
            children: [
                {
                    field: 'TotalReprocess',
                    header: 'Total Reproceso',
                    headerEn: 'Total Reprocess',
                    className: 'medium',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },



        {
            field: 'KgsLavado',
            header: 'Lavado (Kgs)',
            headerEn: 'Washing (Kgs)',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
        },

        //PORCENTAJE Produccion PRIMERA----------------------------------------------------------

        {
            headerName: 'Porcentaje Producción Primera',
            headerNameEn: 'First Production Percentage',
            children: [
                {
                    field: 'CottonFP',
                    header: 'Algodón',
                    headerEn: 'Cotton',
                    className: 'small',
                    Format: 'Porcentaje',
                    // Sumary: 'sum',
                },
                {
                    field: 'PolyFP',
                    header: 'Sintético',
                    header: 'Synthetic',
                    className: 'small',
                    Format: 'Porcentaje',
                    // Sumary: 'sum',
                },
            ]
        },

        // {
        //     field: 'CottonRP',
        //     header: 'CottonRP',
        //     className: 'small',
        //     Format: 'Currency',
        //     Sumary: 'sum',
        // },
        // {
        //     field: 'PolyRP',
        //     header: 'PolyRP',
        //     className: 'small',
        //     Format: 'Currency',
        //     Sumary: 'sum',
        // },
        // {
        //     field: 'CottonCCP',
        //     header: 'CottonCCP',
        //     className: 'small',
        //     Format: 'Currency',
        //     Sumary: 'sum',
        // },
        // {
        //     field: 'PolyCCP',
        //     header: 'PolyCCP',
        //     className: 'small',
        //     Format: 'Currency',
        //     Sumary: 'sum',
        // },
        // {
        //     field: 'TRCP',
        //     header: 'TRCP',
        //     className: 'small',
        //     Format: 'Currency',
        //     Sumary: 'sum',
        // },
        // {
        //     field: 'WP',
        //     header: 'WP',
        //     className: 'small',
        //     Format: 'Currency',
        //     Sumary: 'sum',
        // },
        {
            headerName: 'Proyección',
            headerNameEn: 'Projection',
            children: [
                {
                    field: 'KgsProyeccionAlgodon',
                    header: 'Algodón',
                    headerEn: 'Cotton',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'KgsProyeccionSintetico',
                    header: 'Sintético',
                    headerEn: 'Synthetic',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'KgsTotalProyeccion',
                    header: 'Total',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
            ]
        },

        {
            headerName: 'TOTALES',
            headerName: 'TOTALS',
            children: [
                {
                    // Rollos
                    field: 'KgsTiC',
                    header: 'Algodón',
                    headerEn: 'Cotton',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                    frozen: true,
                    alignFrozen: "right",
                },
                {
                    // Rollos
                    field: 'KgsTiS',
                    header: 'Sintético',
                    headerEn: 'Synthetic',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                    frozen: true,
                    alignFrozen: "right",
                },
                {
                    // Rollos
                    field: 'KgsTotalT',
                    header: 'Total',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                    frozen: true,
                    alignFrozen: "right",
                },
            ]
        },
    ]

    const tableT = {
        Data: tempoCotton1,
        Columns: columns
    };


    useEffect(() => {
        getInfo();
    }, [])


    useEffect(() => {
        getInfo();
    }, [date])

    useEffect(() => {
        if (getDatos) {
            getInfo()
        }
    }, [getDatos])

    useEffect(() => {
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);

        // Cleanup function to remove the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (!visible) {
            const interval = setInterval(() => {

                getInfo();
            }, 500000);
            return () => {
                getInfo();
                clearInterval(interval);
            };
        }
    }, [visible])

    //   console.log(altura)
    // hCount2
    // className={visible && 'hCount2'}
    return (
        <div style={{ height: altura ? "100%" : "58vh", width: '100%' }} id="ProduccionCat"  >
            <Loader loading={loading} querySelector={"#ProduccionCat"} />
            <div className={visible ? 'hCount2' : 'd-flex flex-column '}  >
                <div className='cottonP'>
                    <Card
                        // style={{ width: '100%' }}
                        titulo={<h4 className='mt-2'>{getLabel(baseLang, "Algodon", config.language)}</h4>}
                        contenido={
                            <div className="p-3" style={{ display: "flex" }}>
                                <div style={{ width: "100%" }}>
                                    <Chart
                                        height={visible ? '300px' : '200px'}
                                        // width='100%'
                                        data={chartCotton.data}
                                        options={chartCotton?.options}
                                        plugins={[ChartDataLabels]}
                                    />
                                </div>
                            </div>
                        }
                    />
                </div>

                <div className='syntheticP'>
                    <Card
                        // style={{ height: '390px' }}
                        titulo={<h4 className='mt-2'>{getLabel(baseLang, "Sintetico", config.language)}</h4>}
                        contenido={
                            <div className="p-3" style={{ display: "flex" }}>
                                <div style={{ width: "100%" }}>
                                    <Chart
                                        height={visible ? '300px' : '200px'}

                                        data={chartPoly.data}
                                        options={chartPoly?.options}
                                        plugins={[ChartDataLabels]}
                                    />
                                </div>
                            </div>}
                    />
                </div>

            </div>

            {visible &&
                <div className='pt-4' style={{ width: "100%", height: "37vh" }}>
                    <AgGrid table={tableT} />
                </div>
                // <div style={{ display: "flex" }} >
                // </div>
            }
            <DiarioMetasDiarias
                dialogMetas={showDialogDiario}
                onHide={() => setShowDialogDiario(false)}
                semana={semana}
                setSemana={setSemana}
                date={date}
                IdCategoria = {IdCategoria}
            />
        </div>
    );


    // return (
    //     <div className='metasProd'>
    //         <div style={{ height: altura ? "100%" : "100vh" }} id="ProduccionCat">
    //             <Loader loading={loading} querySelector={"#ProduccionCat"} />

    //             <div className='d-flex'>
    //                 <Card
    //                     contenido={
    //                     <div className="p-3" style={{ display: "flex" }}>
    //                         <div style={{ width: "685px" }}>
    //                         <Chart
    //                             data={chartCotton.data}
    //                             options={optionsChart}
    //                             plugins={[ChartDataLabels]}
    //                         />
    //                         </div>
    //                     </div>}
    //                 />

    //                 <Card
    //                     contenido={
    //                     <div className="p-3" style={{ display: "flex" }}>
    //                         <div style={{ width: "685px" }}>
    //                         <Chart
    //                             data={chartPoly.data}
    //                             options={optionsChart}
    //                             plugins={[ChartDataLabels]}
    //                         />
    //                         </div>
    //                     </div>}
    //                 />

    //             </div>

    //             <div style={{ display: "flex", gap: 10 }} className="mt-4">
    //                 <div style={{ width: "100%", height: "37vh" }}>
    //                     <AgGrid table={tableT} />
    //                 </div>
    //             </div>

    //         </div>
    //     </div>

    // );
};

export default MetasSemanalesPorCategoria;
